import * as actions from "./actionsTypes";

const initialData = {
  loading: false,
  loadingById: false,
  saveLoading: false,
  competenciesTypesLength: 0,
  competenciesTypes: [],
  competenciesType: {},
  competenciesTypeError: "",
  formError: "",
};

export default function CompetenciesTypeReducer(state = initialData,action) {
  switch (action.type) {
    case actions.LOADING_COMPETENCIES_TYPE:
      return { ...state, loading: action.payload };
    case actions.LOADING_COMPETENCIES_TYPE_BY_ID:
      return { ...state, loadingById: action.payload };
    case actions.SAVE_LOADING_COMPETENCIES_TYPE:
      return { ...state, saveLoading: action.payload };
    case actions.GET_COMPETENCIES_TYPE:
      return {
        ...state,
        competenciesTypes: action.payload.competenciesTypes,
        competenciesTypesLength: action.payload.competenciesTypesLength,
      };
    case actions.GET_COMPETENCIES_TYPE_BY_ID:
      return {
        ...state, competenciesType: action.payload
      };
    case actions.FORM_FAIL:
      return { ...state, formError: action.payload };
    case actions.COMPETENCIES_TYPE_FAIL:
      return { ...state, competenciesTypeError: action.payload };
    default:
      return state;
  }
}
